import { render, staticRenderFns } from "./ContentLanguageForm.vue?vue&type=template&id=b93a0c2e&scoped=true&"
import script from "./ContentLanguageForm.vue?vue&type=script&lang=js&"
export * from "./ContentLanguageForm.vue?vue&type=script&lang=js&"
import style0 from "./ContentLanguageForm.vue?vue&type=style&index=0&id=b93a0c2e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93a0c2e",
  null
  
)

export default component.exports